'use strict';

export function smoothScroll(){

    $(function(){

        const speed = 500;
        const header = $(".l-header");
        const urlHash = location.hash; //URLのハッシュタグを取得

        let headerHeight = header.innerHeight();

        // ページ遷移後のスムーススクロール
        if(urlHash){
            $('body,html').stop().scrollTop(0);
            setTimeout(function(){
                let hashTarget = $(urlHash);
                let position = hashTarget.offset().top - headerHeight ;
                $('body,html').animate({scrollTop:position}, speed);
            }, 400);
        }


    // ページ内スムーススクロール
        $('a[href^="#"]').click(function(){

            const href= $(this).attr("href");
            const target = $(href == "#" || href == "" ? 'html' : href);

            headerHeight = header.innerHeight();
            let position = target.offset().top - headerHeight ;

            $('html, body').animate({scrollTop:position}, speed);
    
            // g-navを閉じる
            $('body').removeClass('is-open');
        
            return false;
        });

        // ページトップボタンの表示
        const $pageTop = $('.js-page-top-btn');

        $(window).scroll(function(){

            if ($(this).scrollTop() > 100) {
                $pageTop.addClass("is-active");
            } else {
                $pageTop.removeClass("is-active");
            }

        });

    });
}